<template>

  <div>
    <div class="col-12 mb-4">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-8 offset-lg-2 text-secondary">
            <p class="pb-3 text-center" v-if="show_datenschutz">Mit dem Absenden der Anfrage erklären Sie sich mit unserer <a style="text-decoration: underline" class="text-secondary" href="#" v-b-modal.modal-datenschutzerklaerung>Datenschutzerklärung</a> und der <a style="text-decoration: underline" class="text-secondary" href="#" v-b-modal.modal-widerrufsbelehrung>Widerrufsbelehrung</a> einverstanden.</p>
          </div>
          <div class="col-12 col-lg-8 offset-lg-2 text-center text-secondary">
            <p v-if="show_berlin" class="mb-2">
              Strenger Datenschutz - gewährleistet durch:
            </p>
            <img v-if="show_berlin" class="mb-3" alt="Berliner Beauftragte für Datenschutz" src="../../assets/BlnBDI_logo.svg" width="200"/>
            <p>
              VON RUEDEN Partnerschaft von Rechtsanwälten
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Modals -->
    <Datenschutzerklaerung v-if="show_datenschutz" />

    <!--<Widerrufsbelehrung />-->
    <Widerrufsbelehrung v-if="show_datenschutz" />
  </div>

</template>
<script>
import Datenschutzerklaerung from "@/views/Datenschutzerklaerung";
import Widerrufsbelehrung from "@/views/Widerrufsbelehrung";
export default {
  components: {Datenschutzerklaerung, Widerrufsbelehrung},
  props: ['show_datenschutz','show_berlin'],
}
</script>
